import React, { useState, useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import copy from 'copy-to-clipboard'
import { FiX } from 'react-icons/fi'

import { calcExpires } from '/components/utils'
import { Button as ChaliceButton } from '/components/theme/button/Button'
import { PAGEURL } from '/constants'

const CouponCode = inject('store')(
  observer(({ cta, product, close }) => {
    const [expires, setExpires] = useState(calcExpires(cta.expires))
    const url = PAGEURL.PRODUCT_DETAILS_REDIRECT(product.slug, cta.id)
    const copyText = async () => {
      try {
        await copy(cta.coupon_code)
        toast.info('Code Copied')

        setTimeout(() => {
          window.open(url, '_blank').focus()
        }, 250)
      } catch (e) {
        console.error(e)
      }
    }
    useEffect(() => {
      if (!cta.expires) {
        return
      }
      const id = setInterval(() => {
        let s = calcExpires(cta.expires)
        setExpires(s)
      }, 1000)
      return () => {
        clearInterval(id)
      }
    }, [cta.expires, setExpires])
    return (
      <Wrapper>
        <FiX
          onClick={close}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            cursor: 'pointer'
          }}
        />
        <H2>{cta.title}</H2>
        {expires && <Expires>Expires: {expires}</Expires>}
        <Instructions>{cta.description}</Instructions>
        <div>
          <CodeWrapper>
            <Code>{cta.coupon_code}</Code>
            <ChaliceButton style={{ borderRadius: '0' }} onClick={copyText}>
              Copy Code
            </ChaliceButton>
          </CodeWrapper>
        </div>
        {url && (
          <div className="text-center">
            <a href={url} target="_blank" rel="noreferrer">
              <small>Shop {product?.partner?.name}</small>
            </a>
          </div>
        )}
      </Wrapper>
    )
  })
)

const Wrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
`

const Expires = styled.small`
  text-align: center;
`

const H2 = styled.h2`
  text-align: center;
  margin: 0;
  padding: 0;
`

const Instructions = styled.div`
  text-align: center;
`

const CodeWrapper = styled.div`
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.primary};
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  flex-direction: row;

  & > * {
    width: 50%;
  }
`

const Code = styled.div`
  font-size: 1.5em;
  font-weight: bold;
  padding: 10px;
  font-family: monospace;
  display: flex;
  align-items: center;
`

export default CouponCode
